<template>
  <div class="box" v-if="batchs && batchs.length > 0">
    <div class="button1">
      <el-button type="primary" size="small" @click="setHidden(data.resultId, 0)" v-if="data.isHidden === 1">设为可见
      </el-button>
      <el-button type="primary" size="small" @click="setHidden(data.resultId, 1)" v-else>设为不可见</el-button>
      <el-button type="success" size="small" v-permission="'400116'" @click="previewAdmit()">设置预录取</el-button>
      <el-button type="danger" size="small" v-permission="'400117'" @click="removeByBatch(null)">删除</el-button>
    </div>
    <div v-for="item in batchs" :key="item.batch">
      <div v-if="(item.specialtyList && item.specialtyList.length > 0) ||
    (item.collegeList && item.collegeList.length > 0)
    " style="margin-bottom: 30px">
        <div class="button">
          <div>{{ item.batch }}</div>
          <div>
            <el-button size="small" @click="changeradio(item.batch, 2, item.switch)"
              v-if="item.switch !== 1 && item.switch !== 3" :type="item.voPa === 2 ? 'primary' : ''">志愿方案</el-button>
            <el-button size="small" @click="changeradio(item.batch, 1, item.switch)"
              v-if="item.switch === 1 && item.switch !== 3" :type="item.voPa === 1 ? 'primary' : ''">志愿方案</el-button>
            <el-button size="small" @click="changeradio(item.batch, 3, item.switch)" v-if="item.switch === 3"
              :type="item.voPa === 3 ? 'primary' : ''">志愿方案</el-button>
            <!-- <el-button size="small" @click="changeradio(item.batch, item.switch, item.switch)" :type="item.switch === item.voPa ? 'primary' : ''">志愿方案</el-button> -->
            <el-button size="small" @click="changeradio(item.batch, 1, item.switch)" v-if="item.switch !== 1"
              :type="item.voPa === 1 ? 'primary' : ''">院校方案</el-button>
            <el-button type="primary" size="small" @click="dayin(item.batch, item.switch, item.voPa)">打印</el-button>
            <el-button type="danger" size="small" @click="removeByBatch(item.batch)">删除</el-button>
          </div>
        </div>
        <volunteerTableScheme :voPa="item.switch" :switchValue="item.voPa" @gettabledata="gettabledata" :draftform="item.specialtyList ? item.specialtyList : item.collegeList
    " />
      </div>
    </div>
    <div class="footerbox">
      <el-row>
        <el-col :span="6"> 预录取院校： {{ data.expectCollege }}</el-col>
        <el-col :span="6"> 院校最低分： {{ data.scoreCollege }}</el-col>
        <el-col :span="12"> 院校最低位次： {{ data.accumulateLowest }}</el-col>
      </el-row>
    </div>
    <div class="footerbox">
      <el-row>
        <el-col :span="6"> 实录取院校： {{ data.actualCollege }}</el-col>
        <el-col :span="6">
          实录取专业：
          <el-tooltip effect="dark" :content="data.actualSpecialty" placement="top">
            <span class="overflow"> {{ data.actualSpecialty }}</span>
          </el-tooltip>
        </el-col>
        <el-col :span="6"> 院校最低分： {{ data.scoreCollege2 }}</el-col>
        <el-col :span="6"> 院校最低位次： {{ data.accumulateLowest2 }}</el-col>
      </el-row>
    </div>
    <el-dialog title="下载打印" :visible.sync="dialogVisible" width="500px">
      <span>
        <el-radio v-model="fraction" label="1">显示分数</el-radio>
        <el-radio v-model="fraction" label="0">不显示分数</el-radio>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="exportTemplate()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="添加到模板" :visible.sync="showAddTemplateDialog" width="450px">
      <el-form :model="addTemplateParam">
        <el-form-item label="模板方案名称:" label-width="140px">
          <el-input v-model="addTemplateParam.templateName" size="small" style="width: 200px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddTemplateDialog = false" size="small">取 消</el-button>
        <el-button type="primary" @click="saveTemplete" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
  <div v-else class="nodata">
    暂无志愿方案
  </div>
</template>

<script>
import axios from "@/util/request";
import volunteerTableScheme from "./volunteerTableScheme.vue";
import {
  getPlanDetail,
  saveaspirationplan,
  previewAdmit,
  systemAssess,
  saveTemplete,
  removeByBatch,
  setHidden
} from "@/api/serviceManagement.js";
export default {
  components: {
    volunteerTableScheme,
  },
  props: {
    userform: {
      Type: Object,
      default: () => { },
    },
    oneId: {
      Type: String,
      default: "",
    },
  },
  watch: {
    userform: {
      immediate: true, //绑定值就开始执行监听，而不是等值改变。
      handler(newValue, oldValue) {
        this.user = newValue;
        if (this.user.province && this.user.graduateYear) {
          // this.getProvincePage();
        }
      },
      deep: true,
    },
    oneId: {
      immediate: true, //绑定值就开始执行监听，而不是等值改变。
      handler(newValue, oldValue) {
        this.id = newValue;
        this.getPlanDetail();
      },
      deep: true,
    },
  },
  data() {
    return {
      voPa: 0,
      switch1: 0,
      dataType: null,
      activeName: "",
      dialogVisible: false,
      user: {},
      batchs: [],
      id: "",
      fraction: "1",
      tabledata: [],
      data: {}, //志愿方案详情
      showAddTemplateDialog: false,
      addTemplateParam: {
        templateName: null
      }
    };
  },
  mounted() {
    // this.getPlanDetail();
    // this.getProvincePage();
  },
  methods: {
    changeradio(batch, voPa, switchvalue) {
      if (voPa === 1 && switchvalue === 2) {
        this.batchs.forEach((item) => {
          if (item.batch === batch) {
            item.voPa = voPa;
            let tableData = item.specialtyList || [];
            tableData.sort(function (a, b) {
              return a.sort - b.sort;
            });
            item.specialtyList = tableData || [];
            console.log(item.voPa, "当前模式");
          }
        });
      } else {
        let dataType = voPa;
        if (voPa === switchvalue) {
          dataType = 0;
        }
        getPlanDetail({
          admitBatch: batch,
          oneId: this.id,
          dataType: dataType,
          voPa: switchvalue,
        }).then((res) => {
          if (res.code === 1) {
            let tableData = [];
            if (voPa === 1) {
              tableData = res.data.collegeList || [];
              // tableData.forEach((item) => {
              //   item.isort = item.sort;
              // });
            }
            if (dataType === 0 || voPa === 2) {
              tableData = res.data.specialtyList || [];
              // if (voPa === 2) {
              //   tableData.forEach((item) => {
              //     item.isort = item.psort;
              //   });
              // }
            }
            this.batchs.forEach((item) => {
              if (item.batch === batch) {
                item.voPa = voPa;
                item.specialtyList = tableData || [];
                console.log(item.voPa, "当前模式");
              }
            });
          }
        });
      }
    },
    removeByBatch(batch) {
      this.$confirm(
        batch ? `是否删除${batch}志愿方案?` : "是否删除志愿方案?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        removeByBatch({ admitBatch: batch, oneId: this.id }).then((res) => {
          if (res.code === 1) {
            this.$message.success("删除成功");
            this.getPlanDetail();
          } else {
            this.$message.info(res.msg);
          }
        });
      });
    },
    dayin(batch, voPa, switch1) {
      this.voPa = voPa;
      this.switch1 = switch1;
      this.activeName = batch;
      this.dialogVisible = true;
    },
    // 志愿方案打印
    exportTemplate() {
      let data = {
        type: this.switch1 - 0,
        admitBatch: this.activeName,
        oneId: this.id,
        source: 1,
        voPa: this.voPa - 0,
        fraction: this.fraction - 0,
      };
      let type = "";
      if (this.switch1 === 1) {
        type = "院校";
      }
      if (this.switch1 === 2) {
        type = "专业";
      }
      if (this.switch1 === 3) {
        type = "专业组";
      }
      axios({
        method: "post",
        url: "/com/had-login/aspiration/aspiration-plan/vertical/exportTemplate",
        data: data,
        responseType: "blob",
      })
        .then((res) => {
          this.dialogVisible = false;
          const elink = document.createElement("a");
          elink.download =
            this.userform.realName + this.activeName + type + "志愿方案.xlsx"; //定义表格名称，后缀是文件格式
          elink.style.display = "none";
          const blob = new Blob([res], {
            type: "application/vnd.ms-excel",
          });
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 预览
    preview(batch, voPa) {
      let routeData = this.$router.resolve({
        path: "/volunteerPreview",
        query: {
          oneId: this.id,
          studentId: this.user.studentId,
          activeName: batch,
          voPa: voPa,
          source: 1,
        },
      });
      window.open(routeData.href, "_blank");
    },

    addTemplateClick() {
      this.addTemplateParam.templateName = '';
      this.showAddTemplateDialog = true;
    },

    //添加到模板
    saveTemplete() {
      if(!this.addTemplateParam.templateName){
        this.$message.warning("请输入模板方案名称")
        return;
      }

      console.log(this.user, "用户信息")
      let form = {};
      (form.accumulate = this.user.scores.accumulate),
        (form.actualCollege = this.data.actualCollege),
        (form.actualSpecialty = this.data.actualSpecialty),
        (form.examProvince = this.user.examProvince),
        (form.examProvinceId = this.user.province),
        (form.examYear = this.user.graduateYear),
        (form.expectCollege = this.data.expectCollege),
        (form.expectSpecialty = this.data.expectSpecialty),
        (form.oneId = this.id),
        (form.score = this.user.adminScore),
        (form.templateName = this.addTemplateParam.templateName),
        saveTemplete(form).then((res) => {
          if (res.code === 1) {
            this.showAddTemplateDialog = false
            this.$message({
              message: "添加到模板完成",
              type: "success",
            });
          } else {
              this.message.error(res.msg)
          }
        });
    },
    // 评审
    systemAssess() {
      // this.previewAdmit();
      systemAssess({ oneId: this.id }).then((res) => {
        if (res.code === 1) {
          this.$message({
            message: "评审完成",
            type: "success",
          });
        }
      });
    },
    // 设置预录取
    previewAdmit(admitBatch) {
      this.systemAssess();
      previewAdmit({ oneId: this.id, admitBatch: admitBatch }).then((res) => {
        if (res.code === 1) {
          this.$message({
            message: "设置预录取成功",
            type: "success",
          });
          this.getPlanDetail();
        }
      });
    },
    //子组件排序后的tabledata
    gettabledata(data) {
      console.log(data, "排序");
      this.tabledata = data;
    },
    //保存志愿方案
    saveaspirationplan() {
      saveaspirationplan({ oneId: this.id, planList: this.tabledata }).then(
        (res) => {
          if (res.code === 1) {
            this.getPlanDetail();
          }
        }
      );
    },
    //tabs切换
    // handleClick(tab, event) {
    //   this.activeName = tab.label;
    //   this.batchs.forEach((item) => {
    //     if (item.batch === this.activeName) {
    //       this.voPa = item.voPa || null;
    //     }
    //   });
    //   this.getPlanDetail();
    // },
    // 看院校看专业
    // changeswitch(val) {
    //   this.getPlanDetail();
    // },
    //获取批次
    // getProvincePage() {
    //   console.log(this.user, "user");
    //   getProvincePage({
    //     year: this.user.graduateYear,
    //     areaProvinceId: this.user.province,
    //   }).then((res) => {
    //     console.log(res, "志愿模板");
    //     let data = res.data || {};
    //     let records = data.records || [];
    //     if (records.length > 0) {
    //       this.batchs = records[0].batchs || [];
    //       this.activeName = this.batchs[0].batch;
    //       this.voPa = this.batchs[0].voPa;
    //       if (this.id) {
    //         this.getPlanDetail();
    //       }
    //     }
    //   });
    // },
    // 看院校
    lookSchool(dataType, batch, voPa) {
      let routeData = this.$router.resolve({
        path: "/lookSchool",
        query: {
          oneId: this.id,
          studentId: this.user.studentId,
          activeName: batch,
          voPa: voPa,
          dataType: dataType,
        },
      });
      window.open(routeData.href, "_blank");
    },
    // 显示隐藏
    setHidden(id, isHidden) {
      setHidden({ resultId: id, isHidden: isHidden }).then(res => {
        if (res.code === 1) {
          this.$message({
            message: '设置成功',
            type: 'success'
          });
          this.getPlanDetail()
        }
      })
    },
    //志愿方案详情
    getPlanDetail() {
      getPlanDetail({
        oneId: this.id,
        dataType: 0,
      }).then((res) => {
        console.log(res, "志愿方案详情");
        if (res.code === 1) {
          this.data = res.data || {};
          if (this.data.batchs) {
            this.data.batchs.forEach((element) => {
              element.switch = element.voPa - 0;
            });
          }
          this.batchs = this.data.batchs || [];
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.nodata {
  width: 100%;
  height: 65vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box {
  max-height: 70vh;
  overflow: auto;
  padding-right: 10px;
  box-sizing: border-box;

  .top {
    padding: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    font-size: 14px;
    margin-bottom: 10px;

    span {
      margin-right: 20px;
    }
  }

  .button1 {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 10px;
  }

  .button {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .tabs {
    position: relative;

    .switch {
      float: right;
      margin-bottom: 10px;
    }
  }

  .footerbox {
    margin: 20px 0px;
    cursor: pointer;
  }

  /deep/.el-tooltip {
    display: inline-block;
    width: calc(100% - 120px);
    overflow: hidden;
    line-height: 25px;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
    margin-bottom: 5px;
    cursor: pointer;
  }
}
</style>
